export default "__VITE_PUBLIC_ASSET__b23b7395__"